module.exports = __webpack_public_path__ + "static/media/icon_settings_admin.af944453.svg";